var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"productDetailWrap cf"},[_c('article',[(_vm.coupon == true)?_c('Coupon',{attrs:{"id":_vm.id}}):_vm._e(),(_vm.catalog === true)?_c('Catalog',{attrs:{"id":_vm.id}}):_vm._e(),(_vm.drawing === true)?_c('Drawing',{attrs:{"id":_vm.id}}):_vm._e(),(_vm.digital === true)?_c('Digital',{attrs:{"id":_vm.id}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }